import React, { Fragment, useRef } from 'react';
import { Comments } from './comments'
import CommentInput from '@widget/post/Details/Components/CommentInput';

export const PostComments = (props) => {
  const { commentInputRef, postData, commentCount, setCommentCount, nextId } = props;
  const pushCommentsRef = useRef(null);
  return (
    <Fragment>
      <CommentInput
        commentInputRef={commentInputRef}
        itemData={postData}
        fetchPostComment={(...rest) => pushCommentsRef.current?.(rest)}
        commentCount={commentCount}
        setCommentCount={setCommentCount}
      />
      <Comments
        comments={postData?.comments || []}
        commentCount={commentCount}
        postData={postData}
        pushCommentsRef={pushCommentsRef}
        nextId={nextId}
      />
    </Fragment>
  )
}
